/**
 * The confirmation before checkout (Art. 16(a) Consumer Rights Directive):
 * the traveller asks for the plan to start now and acknowledges that, if they
 * withdraw within 14 days, they pay for the days already used.
 *
 * Every checkout goes through services/stripe.ts, which asks here first, and
 * one dialog mounted in App answers - so a new "Buy" button cannot skip it.
 */

export const IMMEDIATE_START_EVENT = "healthpass:immediate-start";

export interface ImmediateStartRequest {
  tier: string;
  resolve: (confirmed: boolean) => void;
}

/** Resolves true once confirmed, false when the traveller backs out. */
export function askImmediateStart(tier: string): Promise<boolean> {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent<ImmediateStartRequest>(IMMEDIATE_START_EVENT, {
        detail: { tier, resolve },
      }),
    );
  });
}
